import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { practitionerMedicalServiceTranslationKeys } from '../../../../translations';

import {
   PractitionerMedicalServiceUpdateForm,
   PractitionerMedicalServiceUpdateFormLoader,
} from './PractitionerMedicalServiceUpdateForm';
import { PractitionerMedicalServiceUpdateAction } from './PractitionerMedicalServiceUpdateModal.actions';

type PractitionerMedicalServiceUpdateModalProps = {
   readonly closeModal: VoidFunction;
   readonly practitionerId: number;
   readonly medicalServiceId: number;
   readonly onSuccess: VoidFunction;
};

export const PractitionerMedicalServiceUpdateModal = (
   props: PractitionerMedicalServiceUpdateModalProps
): JSX.Element => {
   return (
      <Modal
         testId={'practitionerMedicalServiceUpdate'}
         title={practitionerMedicalServiceTranslationKeys.update.title}
         width={ModalWidth.HUGE}
      >
         <PractitionerMedicalServiceUpdateFormLoader
            medicalServiceId={props.medicalServiceId}
            practitionerId={props.practitionerId}
         >
            {({ medicalService, taxRates, fiscalPrintEnabled }) => (
               <PractitionerMedicalServiceUpdateForm
                  medicalService={medicalService}
                  taxRates={taxRates}
                  fiscalPrintEnabled={fiscalPrintEnabled}
               >
                  {({ formState, handleSubmit }) => (
                     <>
                        <PractitionerMedicalServiceUpdateAction onSuccess={props.onSuccess}>
                           {({ updatePractitionerMedicalService }) => (
                              <ModalConfirmButton
                                 label={practitionerMedicalServiceTranslationKeys.update.confirm}
                                 onClick={handleSubmit(updatePractitionerMedicalService)}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           )}
                        </PractitionerMedicalServiceUpdateAction>

                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.closeModal}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.closeModal} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </PractitionerMedicalServiceUpdateForm>
            )}
         </PractitionerMedicalServiceUpdateFormLoader>
      </Modal>
   );
};
